import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSelectModule } from '@angular/material/select'
import { ItemTypeEnum } from '@galabid/gb-dashboard/item/data-access'
import { RafflesFacade } from '@galabid/gb-dashboard/raffle/data-access'
import { Store } from '@ngrx/store'
import { TranslateModule } from '@ngx-translate/core'
import { ItemsEntity } from 'libs/gb-dashboard/item/data-access-selected-item/src/lib/+state/selected-item.models'
import * as ItemsActions from 'libs/gb-dashboard/item/data-access/src/lib/+state/items.actions'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import { map, Observable } from 'rxjs'

@Component({
  selector: 'gb-presenter-dialog-raffle-item',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    GbDashboardSharedUiModule,
    TranslateModule,
  ],
  templateUrl: './gb-presenter-dialog-raffle-item.component.html',
  styleUrl: './gb-presenter-dialog-raffle-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterDialogRaffleItemComponent {
  private readonly dialogRef = inject(MatDialogRef<GbPresenterDialogRaffleItemComponent>)
  private readonly rafflesFacade = inject(RafflesFacade)
  private readonly store = inject(Store)

  raffleItemControl = new FormControl<string | null>(null, {
    nonNullable: false,
    validators: [Validators.required],
  })

  raffleItemsLoaded$ = this.rafflesFacade.loaded$
  raffleItems$: Observable<ItemsEntity[]> = this.rafflesFacade.allRaffleItems$.pipe(
    map((items) => items.filter((item) => !!item.raffle_item && item.item_type === ItemTypeEnum.Raffle)),
  )

  continueWithoutRaffleItem(): void {
    this.dialogRef.close(null)
  }

  confirmSelection(): void {
    const raffleItemUuid = this.raffleItemControl.value
    if (!raffleItemUuid) {
      return
    }
    this.dialogRef.close(raffleItemUuid)
  }

  goToItemsList(): void {
    this.dialogRef.close(null)
    this.store.dispatch(ItemsActions.goToItemsList({}))
  }
}
